import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

const ImageViewer = ({
  url,
  name,
  fitToWidth,
  pageRenderWidth,
  docReady,
  onReady,
  transformRef,
}) => {
  const localRef = useRef(null);
  const twRef = transformRef || localRef;
  const computedWidth = fitToWidth && pageRenderWidth ? Math.floor(pageRenderWidth) : undefined;

  useEffect(() => {
    if (!docReady) return;
    if (fitToWidth) {
      const api = twRef.current;
      if (api && typeof api.resetTransform === 'function') {
        api.resetTransform();
      }
    }
  }, [fitToWidth, docReady, twRef]);

  return (
    <div className='dv-canvas'>
      {!docReady && (
        <img
          src={url}
          alt='preload image'
          style={{ position: 'absolute', width: 0, height: 0, opacity: 0, pointerEvents: 'none' }}
          onLoad={onReady}
        />
      )}
      {docReady && (
        <TransformWrapper
          ref={twRef}
          disablePadding
          smooth
          wheel={{ step: 0.2 }}
          pinch={{ step: 0.08 }}
          doubleClick={{ disabled: false, mode: 'zoomIn' }}
          panning={{ velocityDisabled: false, disabled: false }}
          minScale={0.3}
          maxScale={4}
          limitToBounds={false}
          centerOnInit={false}
          velocityAnimation={{ sensitivity: 1, animationTime: 400, animationType: 'easeOut' }}
        >
          <TransformComponent
            wrapperStyle={{ width: '100%', height: '100%' }}
            contentStyle={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src={url}
              alt={`Preview of ${name || 'document'}`}
              className='dv-image'
              style={{ width: computedWidth ? `${computedWidth}px` : '100%', height: 'auto' }}
            />
          </TransformComponent>
        </TransformWrapper>
      )}
    </div>
  );
};

ImageViewer.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string,
  fitToWidth: PropTypes.bool.isRequired,
  pageRenderWidth: PropTypes.number,
  docReady: PropTypes.bool.isRequired,
  onReady: PropTypes.func.isRequired,
  transformRef: PropTypes.object,
};

ImageViewer.defaultProps = {
  name: null,
  pageRenderWidth: undefined,
  transformRef: null,
};

export default ImageViewer;
